"use client";
import React, { memo } from "react";

const ShimmerBox = memo(({ className = "", style, light = false }) => (
  <div
    className={`bg-gradient-to-r ${
      light
        ? "from-gray-100 via-gray-200 to-gray-100"
        : "from-gray-200 via-gray-300 to-gray-200"
    } bg-[length:200%_100%] animate-shimmer ${className}`}
    style={style}
  />
));

ShimmerBox.displayName = "ShimmerBox";

const WORKSPACE_NAV_SHIMMER_KEYS = [
  "ws-nav-1",
  "ws-nav-2",
  "ws-nav-3",
  "ws-nav-4",
  "ws-nav-5",
  "ws-nav-6",
];

const WorkspaceChromeSkeleton = ({ section }) => {
  if (section === "header") {
    return (
      <header className="flex items-center justify-between px-4 py-2.5 bg-white rounded-t-lg min-h-[56px]">
        <div className="flex flex-col gap-1">
          <ShimmerBox className="h-4 w-48" />
          <ShimmerBox className="h-3 w-28" />
        </div>
        <div className="flex items-center gap-2">
          <ShimmerBox className="w-9 h-9 rounded-lg" />
          <ShimmerBox className="w-20 h-9 rounded-lg hidden sm:block" />
          <ShimmerBox className="w-9 h-9 rounded-lg" />
          <ShimmerBox className="w-9 h-9 rounded-lg" />
          <ShimmerBox className="w-9 h-9 rounded-lg hidden sm:block" />
          <ShimmerBox className="w-9 h-9 rounded-lg hidden sm:block" />
          <div className="flex items-center gap-2 pl-1">
            <ShimmerBox className="w-8 h-8 rounded-full" />
            <div className="hidden sm:flex flex-col gap-1">
              <ShimmerBox className="h-3 w-20" />
              <ShimmerBox className="h-2 w-16" />
            </div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <aside className="w-[260px] h-screen bg-white px-4 py-5 flex flex-col">
      <div className="flex flex-col gap-1">
        <div className="mb-6">
          <ShimmerBox className="h-7 w-20 rounded-sm" />
        </div>
        <div className="mb-6">
          <ShimmerBox className="h-11 w-full rounded-xl" />
        </div>
      </div>
      <div className="flex flex-col gap-5">
        {WORKSPACE_NAV_SHIMMER_KEYS.map((navKey) => (
          <div key={navKey} className="flex items-center gap-4">
            <ShimmerBox className="h-[18px] w-[18px] rounded-full" />
            <ShimmerBox className="h-[14px] w-[120px]" />
          </div>
        ))}
      </div>
      <div className="h-px bg-gray-200 my-6" />
      <div className="mt-auto flex flex-col gap-5">
        <div className="flex items-center gap-4">
          <ShimmerBox className="h-[18px] w-[18px] rounded-full" />
          <ShimmerBox className="h-[14px] w-[100px]" />
        </div>
        <div className="flex items-center gap-4">
          <ShimmerBox className="h-[18px] w-[18px] rounded-full" />
          <ShimmerBox className="h-[14px] w-[80px]" />
        </div>
      </div>
    </aside>
  );
};

const GRID_ITEMS_COUNT = 18;
const GRID_ITEMS_ARRAY = Array.from({ length: GRID_ITEMS_COUNT }, (_, i) => i);

const WorkspaceShimmer = ({ showSidebar = true }) => {
  return (
    <div className="flex h-screen w-full flex-col bg-white">
      {/* Consolidated Header + Sidebar shimmer */}
      <WorkspaceChromeSkeleton section="header" />

      <div className="flex h-full flex-1 overflow-hidden">
        {showSidebar && <WorkspaceChromeSkeleton section="sidebar" />}
        {/* Main Content Shimmer */}
        <div className="flex h-full flex-1 flex-col overflow-auto">
          {/* Grid View - File/Folder Cards Shimmer */}
          <div className="px-4 pb-4 pt-4">
            {/* <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm-md:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 lg-xl:grid-cols-5 xl:grid-cols-6 xl-2xl:grid-cols-6 2xl:grid-cols-6 2.25xl:grid-cols-7 2.5xl:grid-cols-8 3xl:grid-cols-10">
              {GRID_ITEMS_ARRAY.map((index) => (
                <FolderModalSkeleton key={index} />
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(WorkspaceShimmer);

